import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as config from "../constants/config";
import * as handlers from "../constants/handlers";

export const customersTabInit = (tabId) => ({
    type: actionTypes.CUSTOMERS_TAB_INIT,
    payload: {
        tabId: tabId
    }
});

export const getCustomers = (tabId, filter) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_CUSTOMERS_BY_PARAMS,
        params: {
            search: filter,
            rowCount: config.MAX_CUSTOMER_LIMIT,
            offset: 0
        }
    },
    method: handlers.GET_CUSTOMERS_BY_PARAMS,
    tabId: tabId
});

export const reloadCustomers = (tabId, filter, offset) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_CUSTOMERS_BY_PARAMS,
        params: {
            search: filter,
            rowCount: config.MAX_CUSTOMER_LIMIT,
            offset: offset
        }
    },
    method: handlers.GET_CUSTOMERS_WITH_OFFSET,
    tabId: tabId
});

export const selectCustomer = (tabId, customerId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_CUSTOMER_DETAIL,
        params: {
            id: customerId
        }
    },
    method: handlers.GET_CUSTOMER_DETAIL,
    tabId: tabId
});

export const selectCustomerOnCustomersTab = (tabId, customerId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_CUSTOMER_DETAIL,
        params: {
            id: customerId
        }
    },
    method: handlers.CUSTOMERS_TAB_GET_DETAIL,
    tabId: tabId
});

export const addCustomer = (tabId, customer) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_CUSTOMER,
        params: {
            name: customer.name,
            phone: customer.phone,
            email: customer.email,
            street: customer.street,
            city: customer.city,
            country: customer.country,
            zipCode: customer.zipCode,
            barcode: customer.barcode,
            marginId: customer.margin,
            marginLocal: customer.margin === null ? null : true,
            identification: customer.identification
        }
    },
    method: handlers.ADD_CUSTOMER,
    tabId: tabId
});

export const addCustomerWithEmail = (tabId, barcode, email) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_CUSTOMER,
        params: {
            name: barcode,
            barcode: barcode,
            email: email
        }
    },
    method: handlers.ADD_CUSTOMER,
    tabId: tabId
});

export const addCustomerLight = (tabId, customer) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_CUSTOMER,
        params: {
            name: customer.name,
            phone: customer.phone
        }
    },
    method: handlers.LIGHT_ADD_CUSTOMER,
    tabId: tabId
});

export const editCustomer = (tabId, customer) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_EDIT_CUSTOMER,
        params: {
            id: customer.id,
            name: customer.name,
            phone: customer.phone,
            email: customer.email,
            street: customer.street,
            city: customer.city,
            country: customer.country,
            zipCode: customer.zipCode,
            barcode: customer.barcode,
            marginId: customer.margin,
            marginLocal: customer.margin === null ? null : true,
            identification: customer.identification
        }
    },
    method: handlers.EDIT_CUSTOMER,
    tabId: tabId
});

export const deleteCustomer = (tabId, customerId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_DELETE_CUSTOMER,
        params: {
            id: customerId
        }
    },
    method: handlers.DELETE_CUSTOMER,
    tabId: tabId
});

export const removeSelectedCustomer = (tabId) => ({
    type: actionTypes.SAVE_CUSTOMER_DETAIL,
    payload: {
        tabId: tabId,
        customer: null
    }
});

export const changeFilter = (tabId, filter) => ({
    type: actionTypes.CUSTOMERS_CHANGE_FILTER,
    payload: {
        tabId: tabId,
        filter: filter
    }
});

export const changeOffset = (tabId, offset) => ({
    type: actionTypes.CUSTOMERS_CHANGE_OFFSET,
    payload: {
        tabId: tabId,
        offset: offset
    }
});

export const getLastCustomers = (tabId, offset) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_LAST_CUSTOMERS,
        params: {
            offset: offset,
            rowCount: config.MAX_CUSTOMER_LIMIT
        }
    },
    method: handlers.GET_LAST_CUSTOMERS,
    tabId: tabId
});

export const openCustomerInNewTab = (customerId) => ({
    type: actionTypes.OPEN_CUSTOMER_IN_NEW_TAB,
    payload: {
        customerId: customerId
    }
});

export const findCustomerByEmail = (tabId, email) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_CUSTOMER_BY_EMAIL,
        params: {
            email: email
        }
    },
    method: handlers.GET_CUSTOMER_BY_EMAIL,
    tabId: tabId
});
